const IndianFlagSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" className="w-5 h-3.5 shrink-0 rounded-[2px] shadow-xs">
    <rect width="900" height="200" fill="#FF9933"/>
    <rect y="200" width="900" height="200" fill="#FFFFFF"/>
    <rect y="400" width="900" height="200" fill="#128807"/>
    <g transform="translate(450,300)">
      <circle r="92" fill="none" stroke="#000080" stroke-width="6.5"/>
      <circle r="16" fill="#000080"/>
      <path d="M0,0 L0,-92 M0,0 L0,92 M0,0 L-92,0 M0,0 L92,0 M0,0 L-46,-80 M0,0 L46,80 M0,0 L-80,-46 M0,0 L80,46 M0,0 L-80,46 M0,0 L80,-46 M0,0 L-46,80 M0,0 L46,-80 M0,0 L-24,-89 M0,0 L24,89 M0,0 L-65,-65 M0,0 L65,65 M0,0 L-89,-24 M0,0 L89,24 M0,0 L-89,24 M0,0 L89,-24 M0,0 L-65,65 M0,0 L65,-65 M0,0 L-24,89 M0,0 L24,-89" stroke="#000080" stroke-width="4"/>
    </g>
  </svg>
);

window.Footer = function Footer({ 
  setActiveTab, 
  openQuoteModal,
  setSelectedIndustrySlug,
  setSelectedProductCategory
}) {
  const [siteContactInfo, setSiteContactInfo] = React.useState({
    address: 'Novaket, Plot No. 3, Sipcot Ph. I, Govinda Agraharam, Hosur, Tamil Nadu, India. Pincode: 635126',
    phones: ['+91 95 977 30787', '+91 96 866 24595'],
    emails: ['info@novatek.co.in', 'it.team@novatek.co.in']
  });

  const [newsletterEmail, setNewsletterEmail] = React.useState('');
  const [newsletterStatus, setNewsletterStatus] = React.useState(null); // null, 'submitting', 'success', 'error'
  const [newsletterMsg, setNewsletterMsg] = React.useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!newsletterEmail || !window.validateEmail(newsletterEmail)) {
      setNewsletterStatus('error');
      setNewsletterMsg('Please enter a valid work email address.');
      return;
    }
    setNewsletterStatus('submitting');
    try {
      const res = await window.apiClient.post('subscribers.php', {
        email: newsletterEmail.trim(),
        source: 'Website Footer'
      });
      if (res.success) {
        setNewsletterStatus('success');
        setNewsletterMsg(res.message || 'Thank you for subscribing to Novatek insights!');
        setNewsletterEmail('');
      } else {
        setNewsletterStatus('error');
        setNewsletterMsg(res.message || 'Subscription failed. Please try again.');
      }
    } catch (err) {
      setNewsletterStatus('error');
      setNewsletterMsg(err.message || 'Unable to connect. Please try again later.');
    }
  };

  const [categories, setCategories] = React.useState([]);

  const [industries, setIndustries] = React.useState([
    { title: 'Railway Testing Systems & Rigs', slug: 'railway', icon: 'train' },
    { title: 'Automotive Test & Automation', slug: 'automotive', icon: 'directions_car' },
    { title: 'Aerospace Test Systems & GSE', slug: 'aerospace', icon: 'flight' },
    { title: 'Industrial Automation & SPM', slug: 'industrial', icon: 'precision_manufacturing' },
    { title: 'R&D & Academic Research', slug: 'rd', icon: 'science' }
  ]);

  const [navVisibility, setNavVisibility] = React.useState({
    projects: true,
    products: true,
    about: true,
    blogs: true,
    careers: true,
    downloads: true,
    contact: true
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await window.apiClient.get('content.php');
        if (res.success && res.data) {
          if (res.data.contact_info) {
            const ci = res.data.contact_info;
            setSiteContactInfo({
              address: ci.address || 'Novaket, Plot No. 3, Sipcot Ph. I, Govinda Agraharam, Hosur, Tamil Nadu, India. Pincode: 635126',
              phones: [ci.phone || '', ci.phone2 || ''].filter(Boolean),
              emails: [ci.email || '', ci.supportEmail || ''].filter(Boolean)
            });
          }
          if (res.data.nav_menu && Array.isArray(res.data.nav_menu)) {
            // Update Engineering Resources visibility
            const vis = {};
            res.data.nav_menu.forEach(item => {
              if (item.id) {
                vis[item.id] = item.visible !== false;
              }
            });
            setNavVisibility(prev => ({ ...prev, ...vis }));

            // Fetch categories for footer
            try {
              window.apiClient.get('categories.php').then(catRes => {
                if (catRes.success && catRes.data) {
                  setCategories(catRes.data);
                }
              });
            } catch (cErr) {
              console.warn('Footer categories fetch warning:', cErr);
            }

            // Update Industries from nav_menu (matches Header dropdown exactly)
            const industriesNav = res.data.nav_menu.find(m => m.id === 'industries');
            if (industriesNav && industriesNav.items) {
              setIndustries(industriesNav.items.filter(i => i.visible !== false).map(i => ({
                title: i.label,
                slug: i.target || i.id,
                icon: i.icon || null
              })));
            }
          }
        }
      } catch (err) {
        console.warn('Footer content fetch warning:', err);
      }
    };

    fetchData();

    const handleSync = () => fetchData();
    window.addEventListener('novatek_content_updated', handleSync);
    window.addEventListener('storage', handleSync);

    return () => {
      window.removeEventListener('novatek_content_updated', handleSync);
      window.removeEventListener('storage', handleSync);
    };
  }, []);

  const getIndustryIcon = (slug, existingIcon) => {
    if (existingIcon) return existingIcon;
    switch(slug) {
      case 'railway': return 'train';
      case 'automotive': return 'directions_car';
      case 'aerospace': return 'flight';
      case 'industrial': return 'precision_manufacturing';
      case 'rd': return 'science';
      default: return 'factory';
    }
  };

  return (
    <footer className="bg-slate-950 text-slate-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Newsletter Subscription Box */}
        <div className="bg-slate-900/60 border border-slate-800/80 rounded-3xl p-6 sm:p-8 md:p-10 flex flex-col lg:flex-row justify-between items-center gap-6 mb-16 shadow-xl relative overflow-hidden backdrop-blur-md">
          {/* Subtle gradient glow decoration */}
          <div className="absolute -top-24 -left-24 w-48 h-48 bg-secondary/5 rounded-full blur-3xl pointer-events-none"></div>
          <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-orange-600/5 rounded-full blur-3xl pointer-events-none"></div>

          <div className="space-y-2 text-center lg:text-left max-w-xl">
            <h3 className="font-sans text-lg sm:text-xl font-bold text-white tracking-tight flex items-center justify-center lg:justify-start gap-2">
              <span className="material-symbols-outlined text-secondary text-xl sm:text-2xl animate-pulse">campaign</span>
              <span>Subscribe to our Engineering Insights</span>
            </h3>
            <p className="font-sans text-slate-400 text-xs sm:text-sm leading-relaxed">
              Get dynamic updates, technical case studies, and blueprints of dynamic testing systems, custom test rigs, and automated cells designed by our design bureau.
            </p>
          </div>

          <div className="w-full lg:w-auto shrink-0 min-w-full lg:min-w-[400px]">
            <form onSubmit={handleSubscribe} className="relative flex flex-col sm:flex-row gap-2 w-full">
              <div className="relative flex-grow">
                <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm">mail</span>
                <input
                  type="email"
                  required
                  placeholder="Enter work email address..."
                  value={newsletterEmail}
                  onChange={(e) => {
                    setNewsletterEmail(e.target.value);
                    if (newsletterStatus === 'error') setNewsletterStatus(null);
                  }}
                  disabled={newsletterStatus === 'submitting'}
                  className="w-full pl-9 pr-3 py-3 text-xs bg-slate-950/80 border border-slate-800 rounded-xl text-slate-200 placeholder-slate-500 outline-none focus:border-secondary focus:ring-1 focus:ring-secondary transition-all font-mono"
                />
              </div>
              <button
                type="submit"
                disabled={newsletterStatus === 'submitting'}
                className="bg-secondary hover:bg-orange-600 disabled:bg-slate-800 disabled:text-slate-500 text-white px-6 py-3 rounded-xl font-sans text-xs font-bold transition-all hover:scale-[1.02] active:scale-95 shadow-md flex items-center justify-center gap-1.5 shrink-0 select-none cursor-pointer"
              >
                <span>{newsletterStatus === 'submitting' ? 'Subscribing...' : 'Subscribe'}</span>
                {newsletterStatus !== 'submitting' && (
                  <span className="material-symbols-outlined text-sm">send</span>
                )}
              </button>
            </form>
            
            {/* Feedback Message */}
            {newsletterStatus && newsletterStatus !== 'submitting' && (
              <div className={`mt-3 px-3 py-2 rounded-xl text-[11px] font-medium font-sans flex items-center gap-2 animate-fadeIn border ${
                newsletterStatus === 'success'
                  ? 'bg-emerald-950/40 border-emerald-800/50 text-emerald-400'
                  : 'bg-red-950/40 border-red-800/50 text-red-400'
              }`}>
                <span className="material-symbols-outlined text-sm shrink-0">
                  {newsletterStatus === 'success' ? 'check_circle' : 'error'}
                </span>
                <span>{newsletterMsg}</span>
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="bg-white p-2.5 rounded-lg inline-block">
              <img 
                src="/logo.png" 
                alt="NOVATEK Logo" 
                width="250"
                height="100"
                className="h-10 w-auto object-contain" 
              />
            </div>
            <p className="text-slate-400 text-xs sm:text-sm leading-relaxed">
              Engineering partner for industrial systems, railway test rigs, automation and high-precision aerospace test solutions.
            </p>
            <div className="pt-2 text-xs font-mono text-slate-400 space-y-1.5 border-t border-slate-800/80 pt-3">
              <div className="flex items-center gap-1.5">
                <span className="material-symbols-outlined text-secondary text-base">location_on</span>
                <span>{siteContactInfo.address}</span>
              </div>
              {siteContactInfo.emails.map((email, idx) => (
                <div key={`email-${idx}`} className="flex items-center gap-1.5">
                  <span className="material-symbols-outlined text-secondary text-base">mail</span>
                  <a href={`mailto:${email}`} className="hover:text-secondary">{email}</a>
                </div>
              ))}
              {siteContactInfo.phones.map((phone, idx) => (
                <div key={`phone-${idx}`} className="flex items-center gap-1.5">
                  <span className="material-symbols-outlined text-secondary text-base">call</span>
                  <a href={`tel:${phone.replace(/\s+/g, '')}`} className="hover:text-secondary">{phone}</a>
                </div>
              ))}
            </div>
          </div>

          {/* Products Column */}
          <div className="space-y-4">
            <h4 className="text-white font-sans text-base font-bold tracking-wide border-b border-slate-800 pb-2">
              Products
            </h4>
            <ul className="space-y-2 text-xs font-sans">
              {categories.map((cat, idx) => (
                <li key={idx}>
                  <button 
                    onClick={() => {
                      if (setSelectedProductCategory) setSelectedProductCategory(cat.name);
                      setActiveTab('products');
                    }} 
                    className="hover:text-secondary transition-colors text-left"
                  >
                    {cat.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries Column */}
          <div className="space-y-4">
            <h4 className="text-white font-sans text-base font-bold tracking-wide border-b border-slate-800 pb-2">
              Industries
            </h4>
            <ul className="space-y-2 text-xs font-sans">
              {industries.map((ind, idx) => (
                <li key={idx}>
                  <button 
                    onClick={() => {
                      if (setSelectedIndustrySlug) setSelectedIndustrySlug(ind.slug);
                      setActiveTab('industries');
                    }} 
                    className="hover:text-secondary transition-colors text-left flex items-center gap-1.5"
                  >
                    <span className="material-symbols-outlined text-xs text-secondary">{getIndustryIcon(ind.slug, ind.icon)}</span>
                    <span>{ind.title}</span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources & Quick Links */}
          <div className="space-y-4">
            <h4 className="text-white font-sans text-base font-bold tracking-wide border-b border-slate-800 pb-2">
              Engineering Resources
            </h4>
            <ul className="space-y-2 text-xs font-sans">
              {navVisibility.products && (
                <li>
                  <button onClick={() => setActiveTab('products')} className="hover:text-secondary transition-colors text-left">
                    Product Machinery Catalogue
                  </button>
                </li>
              )}
              {navVisibility.about && (
                <li>
                  <button onClick={() => setActiveTab('about')} className="hover:text-secondary transition-colors text-left">
                    About Us & Facility
                  </button>
                </li>
              )}
              {navVisibility.blogs && (
                <li>
                  <button onClick={() => setActiveTab('blogs')} className="hover:text-secondary transition-colors text-left">
                    Engineering Insights & Articles
                  </button>
                </li>
              )}
              {navVisibility.careers && (
                <li>
                  <button onClick={() => setActiveTab('careers')} className="hover:text-secondary transition-colors text-left">
                    Careers & Opportunities
                  </button>
                </li>
              )}
              <li>
                <button onClick={() => setActiveTab('india')} className="hover:text-secondary transition-colors text-left flex items-center gap-1.5">
                  <IndianFlagSvg />
                  <span>Proudly Indian</span>
                </button>
              </li>
              {navVisibility.contact && (
                <li>
                  <button onClick={() => setActiveTab('contact')} className="hover:text-secondary transition-colors text-left">
                    Contact / Submit RFQ
                  </button>
                </li>
              )}
            </ul>

            <div className="pt-2">
              <button
                onClick={openQuoteModal}
                className="w-full bg-secondary hover:bg-orange-600 text-white font-mono text-xs font-bold py-2.5 rounded-lg shadow transition-all flex items-center justify-center gap-1.5"
              >
                <span className="material-symbols-outlined text-sm">engineering</span>
                <span>Request Consultation</span>
              </button>
            </div>
          </div>

        </div>

        {/* Bottom Legal & Compliance */}
        <div className="pt-8 mt-8 border-t border-slate-800/80 flex flex-col sm:flex-row justify-between items-center text-xs font-mono text-slate-400 gap-4">
          <p>© {new Date().getFullYear()} NOVATEK Industrial Systems. All rights reserved.</p>
          <div className="flex gap-6">
            <span>ISO 9001:2015 Compliant</span>
            <span>UIC & RDSO Compatible</span>
            <button onClick={() => setActiveTab('admin')} className="hover:text-slate-400">Portal Login</button>
          </div>
        </div>

      </div>
    </footer>
  );
};
